import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { __, __n } from 'i18n-for-browser';

import {dispatchUnreadPopup, getPopupCurrentGame} from "../../helpers/popupHelper";

import ScoreRow from '../elements/ScoreRow';
import ListButton from '../elements/ListButton';
import ContentContainer from '../elements/ContentContainer';
import noAvatar from "../../assets/img/icons/avatar.svg";
import greenArrow from "../../assets/img/arrow_udown_green.svg";
import Defines from "../../Defines";
import PopUp from "../elements/PopUp";

import apiCall from '../apiCall';
import { getGroupAvatarUrl } from '../../helpers/groupHelper';

class GroupPortalHome extends Component {
  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      schoolClassRank: '-',
      schoolRank: '-',
      totalPoints: '-',
      showPopUp: false,
    };
    this.togglePopup = this.togglePopup.bind(this);
  };

  componentWillMount() {
    this.fetchMyRank();
    window.socket.on('finishedSimulationStep', this.fetchMyRank);
    window.socket.on('activate', this.fetchMyRank);
  }

  componentDidMount(){
    const { dispatch, project, gameState } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if (project.EducationProject.nameShort === 'GLXL' && currentRound <= 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtintro_welkom' : 'mlgvtintro_welkom'), dispatch, false, true);
    }
  }

  fetchMyRank = async () => {
    apiCall('/group/myRank', null, 'GET')
      .then(({ schoolClassRank, schoolRank, totalPoints }) => {
        this.setState({
          schoolClassRank,
          schoolRank,
          totalPoints,
        });
      });
  };

  togglePopup = () => {
    this.setState({
      showPopUp: !this.state.showPopUp
    })
  }

  /**
   * Render game buttons using redux state data
   */
  renderGameButtons = () => {
    const { schoolClass } = this.props;

    // Get games from my schoolClass
    if (!Array.isArray(schoolClass.SchoolClassGames)) return null;
    const games = schoolClass.SchoolClassGames.reduce((arr, val) => {
      // Ignore Simulationgame as it has a custom button
      if (val.Game.abbreviation !== 'SS' && val.Game.abbreviation !== 'BO') arr.push(val.Game);
      return arr;
    }, []);

    // Render game buttons
    return games.map((g) => {
      const curGame = Defines.gameLogos.find(game => game.id === g.id);
      const hasGamePage = Defines.gamePageGames.findIndex(game => game.id === g.id) !== -1;
      const hasGamePageContent = getPopupCurrentGame(g.abbreviation) !== false;
      return (
        <ListButton
          key={g.id}
          title={__(g.name)}
          subtitle={`${this.props.project.EducationProject.nameShort === 'GLXL' ? __('sim_globas_verdienen') : ''}`}
          icon={curGame.logo}
          className={'opacity gameButton'}
          onClick={() => {
            if (hasGamePage > -1 && hasGamePageContent) {
              return this.props.history.push(`/portal/gameinfo/${g.id}`)
            }
          }}
        />
      );
    });
  };

  render() {
    const bonus = this.props.schoolClass.SchoolClassGames.find(g => g.Game.abbreviation === 'BO');
    const simGame = Defines.gameLogos.find(game => game.abbreviation.toLowerCase() === 'ss');
    const boGame = Defines.gameLogos.find(game => game.abbreviation.toLowerCase() === 'bo');
    const { showPopUp } = this.state;
    return (
      <div className={'portal-home class-portal ' + (this.props.project.EducationProject.nameShort === 'GLXL' ? '' : 'non-glxl')}>
        <div className={'portal-container'}>
          <div className={'container'}>
            {this.props.project.EducationProject.nameShort === 'GLXL' ? (
              <div className={'score-container'}>
                <div className={'half'}>
                  <Link to={'/portal/teaminfo'}>
                    <div className={'team-info-button'}>
                      <div className={'avatar'}>
                        <div className={!this.props.group.Avatar ? 'img no-avatar' : 'img'}>
                        <span style={{backgroundImage: 'url(' + getGroupAvatarUrl(this.props.group, this.props.project, noAvatar) + ')'}} />
                        </div>
                      </div>

                      <div className={'small-list-button'}>
                        <div className={'inner-list-button'}>
                          <h4>{__("sim_team_info")}</h4>

                          <span className={'arrow-button'}>
                          <img alt={'greenArrow'} src={greenArrow} />
                        </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={'half'}>
                  {this.props.gameState.hideScores ? (
                    <ContentContainer className="disabled-scores-container">
                      <p className={'disabled-scores'}>{__('sim_tussenstand_uitgeschakeld')}</p>
                    </ContentContainer>
                  ) : (
                    <div>
                      <ScoreRow
                        text={__('sim_puntentotaal')}
                        score={this.state.totalPoints || 0}
                        showArrow={true}
                        to="/portal/teaminfo"
                      />
                      <ScoreRow
                        text={__('sim_ranglijst_school')}
                        score={this.state.schoolRank || 0}
                        showMedal={true}
                        showArrow={true}
                        to={`/portal/rankings/${this.props.group.ProjectId}`}
                      />
                      <ScoreRow
                        text={__('sim_ranglijst_klas')}
                        score={this.state.schoolClassRank || 0}
                        showMedal={true}
                        showArrow={true}
                        to={`/portal/rankings/${this.props.group.ProjectId}/${this.props.group.SchoolClassId}`}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : null}
            <div className={'list-button-container'}>
              {this.props.project.EducationProject.nameShort === 'GLXL' ? (
                <ListButton
                  title={__('sim_land_besturen')}
                  subtitle={`${__('sim_globas_verdelen')}`}
                  icon={simGame.logo}
                  className={'opacity gameButton'}
                  onClick={() => {
                    if ((!this.props.gameState.simGameActive && this.props.gameState.currentRound <= 4) || this.props.gameStateInput.processingStepThree !== false) {
                      this.togglePopup()
                    } else {
                      window.location.href = this.props.gameState.simGameEntry;
                    }
                  }}
                />
              ) : (
                <div className={'title-container'}>
                  <h3>{__n('sim_spel', 1)}</h3>
                </div>
              ) }
              {this.renderGameButtons()}
              {bonus ?
                <ListButton
                  title={__('sim_extra_opdrachten')}
                  subtitle={__('sim_bonuspunten')}
                  icon={boGame.logo}
                  className={'opacity gameButton'}
                  onClick={() => {
                    this.props.history.push('/portal/bonuspoints');
                  }}
                /> : ''
              }
              { showPopUp ? (
                <PopUp popUpFooter={true} id={['SIMULATION_SPENDING', 'END'].includes(this.props.gameState.roundData.state) ? 'dlgmlandbesturen_1' : 'dlgmlandbesturen'} closePopUpClick={this.togglePopup}/>
              ) : null }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  user: state.user,
  project: state.project,
  group: state.group,
  schoolClass: state.schoolClass,
  gameState: state.gameState,
  feedBack: state.feedBack,
  gameStateInput: state.gameStateInput,
}))(GroupPortalHome);



// WEBPACK FOOTER //
// ./src/components/desktop/GroupPortalHome.js